import { useContext } from 'react'

import { Form } from 'components/ui/form/Form'
import { jobItemValidation } from 'util/validations'
import { useAddJobItem } from 'hooks/mutations'
import { WrenchIcon } from '@heroicons/react/24/outline'
import { ModalContext } from 'context/ModalContext'
import { Card } from 'components/gsys-ui'
import PartForm from './PartForm'

const AddPartModal = ({ initial }) => {
  const modal = useContext(ModalContext)
  const mutation = useAddJobItem(initial.headId)

  return (
    <Card className="m-auto">
      <Card.Title Icon={WrenchIcon}>Add a part</Card.Title>
      <Card.Body>
        <Form
          validation={jobItemValidation}
          initial={initial}
          mutation={mutation}
          FormComp={PartForm}
          onSubmit={modal.close}
        />
      </Card.Body>
    </Card>
  )
}

export default AddPartModal